import React from 'react';
import { createBrowserRouter, RouterProvider, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import { ThemeProvider } from './components/ThemeProvider';
import ProtectedRoute from './components/ProtectedRoute';
import AdminDashboard from './components/AdminDashboard';
import DeveloperLogin from './components/DeveloperLogin';
import DeveloperRegistration from './components/DeveloperRegistration';
import DeveloperPasswordReset from './components/DeveloperPasswordReset';
import SuperAdminLogin from './components/SuperAdminLogin';
import SuperAdminDashboard from './components/SuperAdminDashboard';
import FlowEditorMaximizedPage from './components/FlowEditorMaximizedPage';
import ChangeLogsPage from './components/ChangeLogsPage';
import ProductionMergePolicyPage from './components/ProductionMergePolicyPage';
import { NotFoundPage, ErrorPage as ThemedErrorPage } from './components/NotFoundPage';
import './App.css';

// Root layout component
function Root() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="braincx-ui-theme">
      <AuthProvider>
        <div className="App">
          <Outlet />
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

// Themed error boundary — wraps in ThemeProvider so CSS variables resolve
function ErrorPage() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="braincx-ui-theme">
      <ThemedErrorPage />
    </ThemeProvider>
  );
}

// Create router with v7 syntax
const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Navigate to="/developer/login" replace />,
      },
      {
        path: "admin",
        element: (
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "developer/login",
        element: <DeveloperLogin />,
      },
      {
        path: "developer/register",
        element: <DeveloperRegistration />,
      },
      {
        path: "developer/reset-password",
        element: <DeveloperPasswordReset />,
      },
      {
        path: "super-admin/login",
        element: <SuperAdminLogin />,
      },
      {
        path: "super-admin",
        element: (
          <ProtectedRoute>
            <SuperAdminDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "flow-editor-maximized",
        element: (
          <ProtectedRoute>
            <FlowEditorMaximizedPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "change-logs",
        element: <ChangeLogsPage />,
      },
      {
        path: "production-merge-policy",
        element: <ProductionMergePolicyPage />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;